import { SpotifyUser, SpotifyArtist } from './spotifyClient.types';

export const SET_ERROR = 'SET_ERROR';
export const SET_USER = 'SET_USER';
export const SET_STATUS = 'SET_STATUS';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ARTISTS = 'SET_ARTISTS';
export const LOGOUT = 'LOGOUT';

export enum STATUS {
  'INITIAL',
  'NO_LOGIN',
  'LOGGED_IN',
  'LOADING',
  'ERROR',
}

export type Action =
  | { type: typeof SET_STATUS; payload: STATUS }
  | { type: typeof LOGOUT }
  | { type: typeof SET_ERROR; payload: string }
  | { type: typeof SET_TOKEN; payload: string | null }
  | { type: typeof SET_USER; payload: SpotifyUser | null }
  | {
      type: typeof SET_ARTISTS;
      payload: {
        longTerm: SpotifyArtist[];
        mediumTerm: SpotifyArtist[];
        shortTerm: SpotifyArtist[];
      };
    };

export type State = {
  status: STATUS;
  error: string | null;
  token: string | null;
  user: SpotifyUser | null;
  artists: {
    longTerm: SpotifyArtist[] | null;
    mediumTerm: SpotifyArtist[] | null;
    shortTerm: SpotifyArtist[] | null;
  };
};
